<template>
  <div>
    <page-header
      icon="mdi-finance"
      :title="$t('finance_page_title')"
      :subtitle="$t('finance_page_subtitle')"
    >
      <template #actions>
        <circle-button
          icon="mdi-refresh"
          color="primary"
          :tooltip="$t('refresh')"
          @click="refreshTab"
        />
        <global-button-print @click="printPage" />
      </template>
    </page-header>

    <div class="finance-tabs-bar">
      <v-tabs
        v-model="tab"
        show-arrows
        color="#1d1d1f"
        slider-color="primary"
        slider-size="3"
        class="finance-tabs"
      >
        <v-tab v-for="item in items" :key="item.value">{{ item.tab }}</v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab" :touchless="true" class="finance-body">
      <v-tab-item v-for="item in items" :key="item.value">
        <div class="finance-content">
          <component
            :is="item.component"
            v-if="items[tab] && items[tab].value === item.value"
            :key="`${item.value}-${refreshKey}`"
            :period.sync="period"
            @navigate="goTo"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import GlobalButtonPrint from "@/components/global/buttons/GlobalButtonPrint.vue";
import {
  FinanceScreenEarnings,
  FinanceScreenSettlements,
  FinanceScreenTransactions,
  FinanceScreenContract,
} from "@/components/restaurant/finance";
import { defaultPeriod } from "@/components/restaurant/finance/constants";

// 4 ekrana umjesto 11 tabova - docs/2026/10/14_10_2026_Backend_specifikacija_finansije_4_ekrana.md.
// "Fakture" se ne prikazuju dok ne stigne [SETTLEMENT] modul (ne praviti prazan tab).
// Promocije su u meniju "Marketing", Refundacije su filter na Transakcijama, Izvoz je dugme na ekranu.
export default {
  name: "RestaurantFinance",

  components: { PageHeader, GlobalButtonPrint },

  data: () => ({
    tab: 0,
    // Period (datum knjiženja) dijele Zarada i Transakcije - promjena na jednom ekranu važi i za drugi.
    period: defaultPeriod(),
    // Prisiljava remount aktivnog ekrana (created() ponovo učita podatke).
    refreshKey: 0,
  }),

  computed: {
    items() {
      return [
        {
          tab: this.$t("finance_tab_earnings"),
          icon: "mdi-cash-multiple",
          component: FinanceScreenEarnings,
          value: "earnings",
        },
        {
          tab: this.$t("finance_tab_settlements"),
          icon: "mdi-file-document-check-outline",
          component: FinanceScreenSettlements,
          value: "settlements",
        },
        {
          tab: this.$t("finance_tab_transactions"),
          icon: "mdi-swap-horizontal",
          component: FinanceScreenTransactions,
          value: "transactions",
        },
        {
          tab: this.$t("finance_tab_contract"),
          icon: "mdi-handshake-outline",
          component: FinanceScreenContract,
          value: "contract",
        },
      ];
    },
  },

  methods: {
    goTo(value) {
      const index = this.items.findIndex((item) => item.value === value);
      if (index >= 0) this.tab = index;
    },
    printPage() {
      window.print();
    },
    refreshTab() {
      this.refreshKey += 1;
    },
  },
};
</script>

<style>
/* Traka tabova je puna širina, a tabovi stoje u istoj koloni kao sadržaj ispod */
.finance-tabs-bar {
  border-bottom: 1px solid #e6e8ec;
}

.finance-tabs-bar .finance-tabs {
  max-width: 1480px;
  margin: 0 auto;
  padding: 0 24px;
}

.finance-tabs .v-tab:first-child {
  padding-left: 0;
}

/* Tabovi u stilu mockupa: bez ikona i bez velikih slova, aktivni taman sa narandžastom linijom */
.finance-tabs .v-tab {
  text-transform: none;
  letter-spacing: 0;
  font-size: 0.95rem;
  font-weight: 600;
  min-width: 0;
  padding: 0 16px;
  color: rgba(0, 0, 0, 0.6) !important;
}

.finance-tabs .v-tab--active {
  color: #1d1d1f !important;
  font-weight: 700;
}

/* Sivo polje i centriran sadržaj, bijele kartice sa mekim obrubom */
.finance-body.v-tabs-items {
  background: #f6f6f4;
  min-height: 60vh;
}

.finance-content {
  max-width: 1480px;
  margin: 0 auto;
  padding: 24px 24px 48px;
}

.finance-body .v-card--outlined {
  border-radius: 12px;
  border-color: #e9e9e6;
  background: #fff;
}

@media (max-width: 600px) {
  .finance-content {
    padding: 16px 12px 32px;
  }

  .finance-tabs-bar .finance-tabs {
    padding: 0 12px;
  }
}

.v-slide-group__prev {
  display: none !important;
}
</style>
